import { render, staticRenderFns } from "./VueEditableGrid.vue?vue&type=template&id=48123a3c&scoped=true&lang=pug&"
import script from "./VueEditableGrid.vue?vue&type=script&lang=js&"
export * from "./VueEditableGrid.vue?vue&type=script&lang=js&"
import style0 from "./VueEditableGrid.vue?vue&type=style&index=0&id=48123a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48123a3c",
  null
  
)

export default component.exports